import { NAME_CHART } from './constant'

export const convertDataAlert = (data) => {
  if (!Object.keys(data).length || !data?.totalAlert) return {}

  return {
    alertNegative: [
      {
        name: 'Negative Alerts',
        value: data?.totalAlertNegative,
        total: data?.totalAlert,
        color: '#0553A5',
        ticker: 'negativeAlerts',
      },
      {
        name: 'NOT',
        value: data?.totalAlert - data?.totalAlertNegative,
        color: '#BCBCBC',
      },
    ],
    alertUnread: [
      {
        name: 'Unread Alerts',
        value: data?.totalAlertUnread,
        total: data?.totalAlert,
        color: '#D96383',
        ticker: 'unreadAlerts',
      },
      {
        name: 'NOT',
        value: data?.totalAlert - data?.totalAlertUnread,
        color: '#BCBCBC',
      },
    ],
  }
}

export const convertDataChart = (data) => {
  const total = data?.totalAlert
  return [
    {
      name: NAME_CHART.COMPANY,
      value: data?.totalAlertCompany,
      color: '#006AA6',
      total,
    },
    {
      name: NAME_CHART.INDUSTRY,
      value: data?.totalAlertIndustry,
      color: '#FFCD60',
      total,
    },
    {
      name: NAME_CHART.MACROECONOMIC,
      value: data?.totalAlertMacroeconomic,
      color: '#D96383',
      total,
    },
  ]
}
